import styled from 'styled-components'

import { StyledCopy as BaseCopy } from 'pages/Login/Login.styled'

export const StyledCopy = styled(BaseCopy)`
  margin-bottom: 40px;
`
